/**
 * Manages the all things having to do with search results
 */
define(['jquery', 'c21', 'c21/ajax', 'c21/Params', 'c21/track', 'c21/cookie', 'c21/LoadingIndicator'], function () {
   "use strict";

   var self,
      exports,
      $ = require('jquery'),
      c21 = require('c21'),
      ajax = require('c21/ajax'),
      Params = require('c21/Params'),
      //maps = require('c21/maps'),
      track = require('c21/track'),
      cookie = require('c21/cookie'),
      LoadingIndicator = require('c21/LoadingIndicator'),
   
      m_page,

      m_iSearchType = null,

      m_bSearchListInitialized = null,
      m_aOnCorrectSearchTypeLoad = [],

      getNumber = function (num, bStripZero) {
         if (!num) return "";
         var strNum = num.toString();
         strNum = Number(strNum.replace(/[^0-9\.]+/g,""));
         return strNum;
      },

      triggerSearchListInitialized = function () {
         if (m_bSearchListInitialized) {
            return;
         }

         m_bSearchListInitialized = true;
         $.each(m_aOnCorrectSearchTypeLoad, function (i, fn) {
            fn();
         });

         m_aOnCorrectSearchTypeLoad = [];
      },

      setSearchType = function (iSearchType) {
         m_iSearchType = iSearchType;
      },

      getInlineSearchType = function () {
         // Search type is inline html
         var strSearchType = $("#lqSearchType").val();
         switch (strSearchType) {
         case "PROPERTIES":
            return self.SEARCH_TYPE.PROPERTY;

         case "AGENTS":
            return self.SEARCH_TYPE.AGENT;

         default:
            return self.SEARCH_TYPE.OFFICE;
         }
      },

      getParamSearchType = function () {
         var oParams = ajax.getParameters();

         if (oParams.t) {
            return parseInt(oParams.t);
         } else {
            return null;
         }
      },

      setNotEmpty = function (params, strParam, strId) {
         var strValue = $("#" + strId).val();

         if (strValue) {
            params[strParam] = strValue;
         }
      },

      trackListing = function (key, type) {
         if (key.indexOf("CBR") < 0 && key.indexOf("ERA") < 0 && key.indexOf("LCE") < 0) {
            key = key.replace("C21", "");

            /* Do internal tracking */
            ajax.report({
               url: "/reporting/listing",
               data: "id=" + key + "&type=" + type
            });

            /* Do list hub & WT Tracking tracking */
            // FIXME: ListHub tracking for commercial
            /*
            switch (type) {
            case "ContactSA":
            case "ContactOff":
               listHub.doTracking(key, 'QUESTION');
               break;
            case "Detail":
               listHub.doTracking(key, 'VIEWED_ON_CHANNEL');
               break;
            case "Dir":
               listHub.doTracking(key, 'DRIVING_DIRECTIONS_CLICKED');
               break;
            case "RetSearch":
               listHub.doTracking(key, 'SEARCH_DISPLAY');
               break;
            case "Saved":
               listHub.doTracking(key, 'LISTING_SAVED');
               break;
            case "Virtual":
               listHub.doTracking(key, 'VIRTUAL_TOUR_CLICKED');
               break;
            case "Slides":
               listHub.doTracking(key, 'SLIDESHOW_CLICKED');
               break;
            case "Floor":
               listHub.doTracking(key, 'FLOORPLANS_CLICKED');
               break;
            case "Email":
               listHub.doTracking(key, 'SHARED');
               break;
            case "PropPrinted":
               listHub.doTracking(key, 'PRINT_MEDIA_CLICKED');
               break;
            }
            */
         }
      },

      lazyLoadSurroundingAreas = function (options) {
         var strParams;

         if ($("body").hasClass("search")) {
            var params = ajax.getParameters();
            params.submitted = true;
            params.v = 3;

            strParams = $.param(params);

            options = $.extend({
               cache: true,
               loadingIndicator : new LoadingIndicator('#refineSearch')
            }, options);

            ajax.doViewEngineAjax('defaultview', '/surroundingAreas.c21', strParams, options);
         } else {
            var aParams = ajax.getParameters();

            strParams = $.param({
               lid : aParams.lid
            });

            options = {
               loadingIndicator : new LoadingIndicator('#refineSearch')
            };

            ajax.doViewEngineAjax('listview', '/surroundingAreas.c21', strParams, options);
         }
      },

      changeSurroundingAreas = function (radius, areas, bRefine) {
         var params = new Params();
         params.remove("sr");
         params.remove("sa");

         if (radius && radius > 0) {
            params.set("sr", radius);
         } else if (areas) {
            var newValue = '';
            for ( var i = 0; i < areas.length; i++) {
               if (newValue.length > 0) {
                  newValue += c21.GS;
               }
               newValue += areas[i];
            }
            params.set("sa", newValue);
         }

         self.doPortalResults(params.get(), (bRefine) ? 'searchView.Refine' : undefined);
      },

      trackAgent = function (key, type) {
         ajax.report({
            url: "/reporting/agent",
            data: "id=" + key + "&type=" + type
         });
      },

      trackOffice = function (key, type) {
         ajax.report({
            url: "/reporting/office",
            data: "id=" + key + "&type=" + type
         });
      },

      buildDefaultParams = function (params, type) {
         var newParams = {
            t: type
         };
         if (params.l) {
            newParams.l = params.l;
         }
         if (params.lid) {
            newParams.lid = params.lid;
         }
         if (type !== 1 && params.of) {
            newParams.of = params.of;
         }
         return newParams;
      },

      setView = function (iView) {
         var params = ajax.getParameters();
         params.v = iView;
         self.doPortalResults(params, 'searchView.Paginate');
         return false;
      },

      doSearch = function (jElement, sParam) {
         var strParamVal = $.trim(jElement.val());
         var params = new Params();
         params.removeParam("s");
         if (!c21.nullSafeStrEquals(strParamVal, params.getParam(sParam))) {
            params.removeParam(sParam);
            if (!c21.nullSafeStrEquals(null, strParamVal)) {
               params.setParam(sParam, strParamVal);
            }

            var mapBoundary = self.getMapBoundaries();
            params.setParam("px", mapBoundary);

            self.doPortalResults(params.getParams(), 'searchView.Refine');
         }
      },

      /**
       * Specificity is a crime... when it comes to URL lengths
       * So, this function makes accurate coordinates consistently fuzzy
       * @param {Number} iCoordinate
       * @return {String} the url-safe, yet slightly less specific, coordinate
       */
      fuzzifyCoordinate = function (iCoordinate) {
         return iCoordinate.toFixed(5).toString();
      };

   exports = self = {
      setPage: function (page) {
         m_page = page;
      },

      setView: setView,
      trackListing: trackListing,
      trackAgent: trackAgent,
      trackOffice: trackOffice,
      clearLiquidMapFacets: function () {
         var params = new Params();
         $.each(params.get(), function (key, value) {
            switch (key) {
            case 't':
            case 'l':
            case 'lid':
            case 'of':
            case 'ag':
            case 'te':
            case 'h':
            case 'o':
            case 'r':
               break;
            default:
               params.remove(key);
               break;
            }
         });

         window.schoolSearch.removeAllSchools();

         var allparams = params.get();
         self.doPortalResults(allparams);
         return false;
      },
      setResultStart: function (page, bGaTrack) {
         var params = ajax.getParameters(),
            rpp = $("#rppActual").html();

         params.s = (rpp * (page - 1)).toString();

         if (bGaTrack) {
            var actionLocation = "Center Lane";
            if ($("#BodyCenterLane").hasClass("fullList")) {
               actionLocation = "List View";
            }

            var iSearchType = self.getSearchType(),
               SEARCH_TYPE = self.SEARCH_TYPE;

            switch (iSearchType) {
            case SEARCH_TYPE.PROPERTY:
               track.doEvent('Hybrid Mapping', 'Property ' + actionLocation, 'Paginate', page);
               break;
            case SEARCH_TYPE.AGENT:
               track.doEvent('Hybrid Mapping', 'Agent ' + actionLocation, 'Paginate', page);
               break;
            case SEARCH_TYPE.OFFICE:
               track.doEvent('Hybrid Mapping', 'Office ' + actionLocation, 'Paginate', page);
               break;
            }
         }

         self.doPortalResults(params, 'searchView.Paginate');
         return false;
      },
      resizeResults: function () {},
      resizeHandoff: function (iHeight) {
         var jHandoffFrame = $('#handoffFrame');

         jHandoffFrame.height(iHeight);
      },
      swapToLocation: function (newLocation, newLID) {
         var params = new Params().get();
         params.l = newLocation;
         params.lid = newLID;
         self.doPortalResults(params);
         return false;
      },
      swapToAgents: function (officeKey, agentName) {
         var params = new Params().get();
         var newParams = buildDefaultParams(params, 2);
         if (officeKey && officeKey.length > 0) {
            delete newParams.lid;
            newParams.of = officeKey;
         }

         newParams.v = 0;
         if (agentName && agentName.length > 0) {
            newParams.q = agentName;
            document.location.href = "/agent-name-search/?" + $.param(newParams);
         } else {
            document.location.href = "/search.c21?" + $.param(newParams);
         }

         return false;
      },
      swapToOffices: function (officeName) {
         var params = new Params().get();
         var newParams = buildDefaultParams(params, 1);
         // self.doPortalResults(newParams);

         newParams.v = 0;
         if (officeName && officeName.length > 0) {
            newParams.q = officeName;
            document.location.href = "/office-name-search/?" + $.param(newParams);
         } else {
            document.location.href = "/search.c21?" + $.param(newParams);
         }

         return false;
      },
      swapToProperties: function (mls) {
         var params = new Params().get();
         var newParams = buildDefaultParams(params, 0);
         // self.doPortalResults(newParams);

         newParams.v = 0;
         if (mls && mls.length > 0) {
            newParams.q = mls;
            document.location.href = "/mls-address-search/?" + $.param(newParams);
         } else {
            document.location.href = "/search.c21?" + $.param(newParams);
         }

         return false;
      },
      removeFacet: function (facet) {
         var params = new Params();
         params.removeParam(facet);

         track.doEvent('Hybrid Mapping', 'Left Lane', 'Remove Search Criteria');

         self.doPortalResults(params.getParams(), 'searchView.Refine');
         return false;
      },
      removeListFacet: function (facet, value) {
         var params = new Params(),
            strParam = params.getParam(facet),
            items = (strParam) ? strParam.split(c21.GS) : [],
            newValue = '',
            strValue = value.toString(),
            i;

         for (i = 0; i < items.length; i++) {
            if (items[i] !== strValue) {
               if (newValue.length > 0) {
                  newValue += c21.GS;
               }
               newValue += items[i];
            }
         }

         if (newValue === '') {
            params.removeParam(facet);
         } else {
            params.setParam(facet, newValue);
         }

         track.doEvent('Hybrid Mapping', 'Left Lane', 'Remove Search Criteria');

         self.doPortalResults(params.getParams(), 'searchView.Refine');

         return false;
      },
      addListFacet: function (facet, value) {
         var params = new Params();
         var param = params.get(facet);
         if (param === undefined || (param.length > 0 && param[0] === c21.NULL)) {
            param = value;
         } else {
            param += (c21.GS + value);
         }
         params.set(facet, param);
         params.removeParam("s");

         self.doPortalResults(params.getParams(), 'searchView.Refine');
         return false;
      },
      addFacet: function (facet, value) {
         var params = new Params();
         params.setParam(facet, value);
         params.removeParam("s");
         self.doPortalResults(params.getParams(), 'searchView.Refine');
         return false;
      },
      changeSearchLocationByValue: function (strParamVal) {
         track.doEvent('Hybrid Mapping', 'Left Lane', 'Refine and Update Location');
         var params = new Params(),
            strTrimmedVal;

         // TODO: Refresh area polygon

         if (!c21.nullSafeStrEquals(strParamVal, params.l)) {
            if (!c21.nullSafeStrEquals(null, strParamVal)) {
               params.setParam('l', strParamVal);
            } else {
               strTrimmedVal = $.trim($('#searchText').val());
               if (c21.nullSafeStrEquals(null, strTrimmedVal)) {
                  return;
               }
               params.setParam('l', strTrimmedVal);
            }

            var mapBoundary = self.getMapBoundaries();
            params.setParam("px", mapBoundary);

            params.setParam('c', 1);
            params.removeParam("s");
            self.doPortalResults(params.getParams(), 'searchView.AllSubView');
         }
      },
      changeSearchLocation: function (jElement) {
         var strParamVal = $.trim(jElement.val());
         return self.changeSearchLocationByValue(strParamVal);
      },
      changeMls: function (jElement, sParam) {
         track.doEvent('Hybrid Mapping', 'Left Lane', 'Refine and Update MLS');
         if (!sParam) sParam = 'mn';
         doSearch(jElement, sParam);
      },
      changeKeywords: function (jElement, sParam) {
         track.doEvent('Hybrid Mapping', 'Left Lane', 'Refine and Update Keywords');
         if (!sParam) sParam = 'kw';
         doSearch(jElement, sParam);
      },

      /**
       * Remove key/value pairs from the object
       * that are in the default state, or are thrown out
       */
      stripDefaultParams: function (obj) {
         var key, val;

         for (key in obj) {
            if (obj.hasOwnProperty(key)) {
               val = obj[key];

               if (key === "t") continue;

               if (val === null) {
                  delete obj[key];
               } else if (val === '') {
                  delete obj[key];
               } else if (val === c21.GS2) {
                  delete obj[key];

               // Strip ranges that start with 0, but don't end with anything
               } else if (val === ("0" + c21.GS2)) {
                  delete obj[key];
               }
            }
         }

         // If search within map is disabled
         if (!obj.sm) {
            // Remove the px values
            delete obj.px;
         }

         // If start is 0
         if ((obj.s === 0) || (obj.s === "0")) {
            delete obj.s;
         }

         return obj;
      },
      /**
       * Change Schools - Perform Property Search 
       * 
       */
      changeSchools: function (schools, radius, locationOverride) {
         var params = new Params();
         params.remove("sc"); //school ids
         params.remove("sn"); //school radius
         params.remove("sk"); //school location override
         params.remove("s");
         
         if (radius && radius > 0) {
            params.set("sn", radius);
         } 
         
         if (schools) {
            var newValue = '';
            for ( var i = 0; i < schools.length; i++) {
               if (newValue.length > 0) {
                  newValue += c21.GS;
               }
               newValue += schools[i];
            }
            params.set("sc", newValue);
         }
         
         if (locationOverride !== null && locationOverride !== "") {
            params.set("sk", locationOverride);
         }
         
         self.doPortalResults(params.get(), 'searchView.Refine');
         return false;
      },
      updateLiquidFacets: function () {
         var params = new Params(),

            // Get all the facet values
            mapBoundary = self.getMapBoundaries(),
            propertyType = $("#lqpropertytype").val(),
            priceMin = getNumber($("#lqMinPriceHidden").val()),
            priceMax = getNumber($("#lqMaxPriceHidden").val()),
            bedsMin = getNumber($("#lqbedroomsFrom").val()),
            bedsMax = getNumber($("#lqbedroomsTo").val()),
            bathsMin = getNumber($("#lqbathroomsFrom").val()),
            bathsMax = getNumber($("#lqbathroomsTo").val()),
            leasePriceMin = getNumber($("#lqleasepriceFrom").val()),
            leasePriceMax = getNumber($("#lqleasepriceTo").val()),
            salePriceMin = getNumber($("#lqsalepriceFrom").val()),
            salePriceMax = getNumber($("#lqsalepriceTo").val()),
            structureSizeMin = getNumber($("#lqstructureSizeFrom").val()),
            structureSizeMax = getNumber($("#lqstructureSizeTo").val()),
            lotSizeMin = getNumber($("#lqlotSizeFrom").val()),
            lotSizeMax = getNumber($("#lqlotSizeTo").val()),
            forSale = getNumber($("#searchForSale").val()),
            forLease = getNumber($("#searchForLease").val()),

            // Throw them in a param object
            oNewFacets = {
               s: null, // removes the 's' param...
               sf: structureSizeMin + c21.GS2 + structureSizeMax,
               pt: propertyType,
               be: bedsMin + c21.GS2 + bedsMax,
               ba: bathsMin + c21.GS2 + bathsMax,
               px: mapBoundary,
               sl: forSale,
               le: forLease
            };

         var jBody = $(document.body);
         if (jBody.hasClass("pageEco") || jBody.hasClass("pageEcoIdx")) {
            $.extend(oNewFacets, {
               pr: priceMin + c21.GS2 + priceMax
            });
         } else if (jBody.hasClass("pageEcoComm")) {
            $.extend(oNewFacets, {
               ac: lotSizeMin + c21.GS2 + lotSizeMax,
               lp: leasePriceMin + c21.GS2 + leasePriceMax,
               sp: salePriceMin + c21.GS2 + salePriceMax
            });
         }

         // Merge the params
         var oOldFacets = params.getParams(),
            oMergedFacets = $.extend({}, oOldFacets, oNewFacets),

            // Strip out empty values
            oStrippedFacets = self.stripDefaultParams(oMergedFacets);

         // Call events as necessary
         if (oOldFacets.sp !== oStrippedFacets.sp) {
            track.doEvent('Hybrid Mapping', 'Property Refine', 'Refine and Update Sale Price');
         }

         if (oOldFacets.lp !== oStrippedFacets.lp) {
            track.doEvent('Hybrid Mapping', 'Property Refine', 'Refine and Update Lease Price');
         }

         if (oOldFacets.sf !== oStrippedFacets.sf) {
            track.doEvent('Hybrid Mapping', 'Property Refine', 'Refine and Update Building Size');
         }

         if (oOldFacets.ac !== oStrippedFacets.ac) {
            track.doEvent('Hybrid Mapping', 'Property Refine', 'Refine and Update Lot Size');
         }

         // Voila
         self.doPortalResults(oStrippedFacets, 'searchView.Refine');
      },

      changePriceFacet: function (event) {
         var params = new Params(),
            priceMin = $("#lowPrice").val(),
            priceMax = $("#highPrice").val(),
            strParamVal = priceMin + c21.GS2 + priceMax;

         if (strParamVal === c21.GS2) {
            strParamVal = '';
         }

         if (!c21.nullSafeStrEquals(strParamVal, params.getParam('pr'))) {
            if (!c21.nullSafeStrEquals(null, strParamVal)) {
               params.setParam("pr", strParamVal);
            } else {
               params.removeParam("pr");
            }
            params.removeParam("s");
            self.doPortalResults(params.getParams(), 'searchView.Refine');
         }
      },

      getMapBoundaries: function (bounds) {
         var boundaries = (bounds || m_page.getMap().getBounds()),
            mx = fuzzifyCoordinate(parseFloat(boundaries.mx)),
            my = fuzzifyCoordinate(parseFloat(boundaries.my)),
            xx = fuzzifyCoordinate(parseFloat(boundaries.xx)),
            xy = fuzzifyCoordinate(parseFloat(boundaries.xy));

         return [mx, my, xx, xy].join(",");
      },

      changeMorePropertySearchOptions: function (event, params) {
         var mapBoundary = self.getMapBoundaries();
         params.setParam("px", mapBoundary);
         params.removeParam("s");
         self.doPortalResults(params.getParams(), 'searchView.Refine');
      },

      removePropertySpecificParams: function (params) {
         params.removeParam("o");
         params.removeParam("sf");
         params.removeParam("sr");
         params.removeParam("pr");
         params.removeParam("mn");
         params.removeParam("of");
         params.removeParam("te");
         params.removeParam("ag");
         params.removeParam("co");
         params.removeParam("sp");
         params.removeParam("pr");
         params.removeParam("fe");
         params.removeParam("ty");
         params.removeParam("oh");
         params.removeParam("pt");
         params.removeParam("rr");
         params.removeParam("rl");
         params.removeParam("fo");
         params.removeParam("ac");
         params.removeParam("yb");
         params.removeParam("q");
         params.removeParam("sm");

         return params;
      },

      removeAgentSpecificParams: function (params) {
         params.removeParam("o");
         params.removeParam("of");
         params.removeParam("la");
         params.removeParam("na");
         params.removeParam("sr");
         params.removeParam("sm");

         return params;
      },

      removeOfficeSpecificParams: function (params) {
         params.removeParam("o");
         params.removeParam("sp");
         params.removeParam("pr");
         params.removeParam("la");
         params.removeParam("na");
         params.removeParam("sr");
         params.removeParam("sm");

         return params;
      },

      switchLiquidMappingToPropertyType: function (event) {
         var params = new Params(),
            mapBoundary = self.getMapBoundaries();

         setSearchType(self.SEARCH_TYPE.PROPERTY);

         params.setParam("px", mapBoundary);
         params.setParam("t", 0);
         params.setParam("s", 0);

         var forSale = params.getParam('sl');
         var forLease = params.getParam('le');
         if (forSale === undefined) {
            params.setParam("sl", 0);
         }
         if (forLease === undefined) {
            params.setParam("le", 0);
         }

         // Not applicable for ECO
         //remove other agent search params
         //params = self.removeAgentSpecificParams(params);

         //remove other office search params
         //params = self.removeOfficeSpecificParams(params);

         m_bSearchListInitialized = false;
         self.doPortalResults(params.getParams(), 'searchView.AllSubView');
      },

      switchLiquidMappingToAgentType: function (event) {
         var params = new Params(),
            mapBoundary = self.getMapBoundaries();

         setSearchType(self.SEARCH_TYPE.AGENT);

         params.setParam("px", mapBoundary);
         params.setParam("t", 2);
         params.setParam("s", 0);

         //remove other property search params
         params = self.removePropertySpecificParams(params);

         //remove other office search params
         params = self.removeOfficeSpecificParams(params);

         m_bSearchListInitialized = false;
         self.doPortalResults(params.getParams(), 'searchView.AllSubView');
      },

      switchLiquidMappingToOfficeType: function (event) {
         var params = new Params(),
            mapBoundary = self.getMapBoundaries();

         setSearchType(self.SEARCH_TYPE.OFFICE);

         params.setParam("px", mapBoundary);
         params.setParam("t", 1);
         params.setParam("s", 0);

         //remove other property search params
         params = self.removePropertySpecificParams(params);

         //remove other agent search params
         params = self.removeAgentSpecificParams(params);

         m_bSearchListInitialized = false;
         self.doPortalResults(params.getParams(), 'searchView.AllSubView');
      },

      changeLiquidMapSearchWithinMapFacet: function (isPageLoad) {
         var params = new Params(),
            mapBoundary = self.getMapBoundaries();

         if (!c21.nullSafeStrEquals(null, mapBoundary)) {
            params.setParam("px", mapBoundary);
            params.setParam("sm", true);
         } else {
            params.removeParam("sm");
         }

         // Dont remove the paginator parameter on entire page load
         if (!isPageLoad) {
            params.removeParam("s");
         }

         self.doPortalResults(params.getParams(), 'searchView.Refine');
      },

      removeLiquidMapSearchWithinMapFacet: function (event) {
         var params = new Params();

         //Remove search within map parameter
         params.removeParam("sm");

         self.doPortalResults(params.getParams(), 'searchView.Refine');

         return false;
      },

      /**
       * Start drawing tool facet
       * @param {Event}  event
       * @param {Array} aCoordinates  the array of lon,lat values
       *                           Ex: [-112,33,-111,33,-111,34,-111.5,34.5,-111.5,35]
       */
      changeLiquidMapDrawingToolFacet: function (event, aCoordinates) {
         var params = new Params(),
            mapBoundary = self.getMapBoundaries(),
            aFuzzyCoodinates = []; // Array of fuzzy coordinates

         $.each(aCoordinates, function (i, iCoordinate) {
            var strFuzzy = fuzzifyCoordinate(iCoordinate);
            aFuzzyCoodinates.push(strFuzzy);
         });

         var strFuzzyCoordinates = aFuzzyCoodinates.join(',');

         if (!c21.nullSafeStrEquals(strFuzzyCoordinates, params.getParam('dt'))) {
            if (!c21.nullSafeStrEquals(null, strFuzzyCoordinates)) {
               params.setParam("px", mapBoundary);
               params.setParam("dt", strFuzzyCoordinates);
            } else {
               params.removeParam("dt");
            }
            //remove params
            params.removeParam("s");
            params.removeParam("sm");
            self.doPortalResults(params.getParams(), 'searchView.Refine');
         }
      },
      removeLiquidMapDrawingToolFacet: function (event) {
         var params = new Params();
         params.removeParam("dt");

         self.doPortalResults(params.getParams(), 'searchView.Refine');
         return false;
      },
      loadMoreSearchOptions: function (event) {
         var params = ajax.getParameters();
         params.submitted = true;

         ajax.doViewEngineAjax(
            'SearchMoreOptions',
            '/moresearchoptions.c21',
            $.param(params),
            {
               cache: true
            }
         );
      },
      loadLanguageSearchOptions: function (event) {
         var params = ajax.getParameters();
         params.submitted = true;

         ajax.doViewEngineAjax(
            'SearchLanguageOptions',
            '/moresearchoptions.c21',
            $.param(params),
            {
               cache: true
            }
         );
      },
      changeMoreLanguageSearchOptions: function (event, params) {
         var mapBoundary = self.getMapBoundaries();
         params.setParam("px", mapBoundary);
         params.removeParam("s");
         self.doPortalResults(params.getParams(), 'searchView.Refine');
         return false;
      },
      getAgentSearchListForOffice: function (event, ofID, fnCallback) {
         var params = ajax.getParameters();
         params.of = ofID;
         ajax.doViewEngineAjax(
            'AgentsSearchOverlay',
            '/agentsearch.c21',
            $.param(params),
            {
               cache: true,
               callback: fnCallback
            }
         );
      },

      handleHash: function (params) {
         self.doPortalResults(ajax.getParameters());
      },

      doPortalResults: function (params, strSubView, fnComplete) {
         var jEl, strPrefix, strSuffix, strPage;

         params = self.stripDefaultParams(params);

         setNotEmpty(params, "reqid", "idxRequestID");
         setNotEmpty(params, "reqts", "idxRequestTS");
         setNotEmpty(params, "prevSort", "prevSort");
         setNotEmpty(params, "feed", "idxfeed");

         switch (strSubView) {
         case 'searchView.Paginate':
            jEl = $('#BodyCenterLane');
            strSuffix = "/paginate/";
            break;

         case undefined:
         case 'searchView.AllSubView':
            strSuffix = "/all/";
            jEl = $('#BodyLeftLane, #BodyRightLane, #BodyCenterLane');
            break;

         case 'searchView.Refine':
            strSuffix = "/refine/";
            jEl = $('#BodyLeftLane, #BodyRightLane, #BodyCenterLane');
            break;

         default:
            //if (m_page && m_page.getMap()) {
            //   m_page.getMap().clearAll();
            //}

            jEl = $('#BodyLeftLane, #BodyRightLane, #BodyCenterLane');
         }

         var jBody = $(document.body);

         if ( (jBody.hasClass("pageEco")) || (jBody.hasClass("pageEcoIdx") && document.location.pathname === "/search/") ) {
            strPrefix = "/eco/search";
         }else if (jBody.hasClass("pageEcoIdx")) {
            strPrefix = "/eco/idxsearch";
         } else if (jBody.hasClass("pageEcoComm")) {
            strPrefix = "/eco/commsearch";
         }

         strPage = strPrefix + strSuffix;

         ajax.fetchView({
            subView: strSubView || 'searchView.AllSubView',
            url: strPage,
            query: $.param(params),
            updateHash: true,
            loadingIndicator: new LoadingIndicator(jEl),
            cache: true,
            callback: function () {
               if (fnComplete) {
                  fnComplete.apply(this, arguments);
               }

               triggerSearchListInitialized();
            }
         });
      },

      /**
       * Perform GEO IP Search
       * 
       */
      doGeoIPSearch: function (searchtype) {
         //Get the last location
         var strLastLocationLID = cookie.get("LAST_LOCATION") || "";

         //var clientip = "74.125.224.240";  //www.google.com test case      
         //var clientip = "159.53.84.126";  //www.chase.com test case
         var clientip = "";

         ajax.doViewEngineAjax(
            'geoipsearch',
            "/geoip.c21",
            $.param({
               type: searchtype,
               lid: strLastLocationLID,
               ipaddress: clientip,
               submitted: true
            }),
            {
               cache: false
            }
         );
      },

      getSearchType: function () {
         var iParamSearchType;

         if (m_iSearchType === null) {
            iParamSearchType = getParamSearchType();

            if (iParamSearchType === null) {
               m_iSearchType = getInlineSearchType();
            } else {
               m_iSearchType = iParamSearchType;
            }

            //Hide the agent and office tabs if user searches listings by agent/office
            if ($("#showPropertyTabOnly").val() === 'true') {
               m_iSearchType = self.SEARCH_TYPE.PROPERTY;
               $("#agentSearchType").hide();
               $("#officeSearchType").hide();
            }
         }

         return m_iSearchType;
      },

      onSearchListInitialized: function (fnComplete) {
         if (m_bSearchListInitialized === null) {
            m_bSearchListInitialized = self.isPageUsingInlineSearchList();
         }

         if (m_bSearchListInitialized) {
            fnComplete();
         } else {
            m_aOnCorrectSearchTypeLoad.push(fnComplete);
         }
      },

      /**
       * Returns whether the page is using or discarding the inline HTML search results
       */
      isPageUsingInlineSearchList: function () {
         //return (self.getSearchType() === getInlineSearchType());
         return !ajax.areHashParamsDifferent();
      },

      SEARCH_TYPE: {
         PROPERTY: 0,
         OFFICE: 1,
         AGENT: 2
      },

      lazyLoadSurroundingAreas: lazyLoadSurroundingAreas,
      changeSurroundingAreas: changeSurroundingAreas
   };

   return exports;
});
